module.exports = [
	{
		"title": "How to write robust apps every time, using “The Clean Architecture”",
		"description": "A brief explanation on the Clean Architecture model, with a sample application written in React/Redux/TypeScript. Over 3.4k claps from 650+ people.",
		"url": "https://medium.freecodecamp.org/how-to-write-robust-apps-consistently-with-the-clean-architecture-9bdca93e17b"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/articles.json
// module id = 212
// module chunks = 5